module.exports = __webpack_public_path__ + "img/banner_3.e4afc7d6.jpg";